import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { RCIcon } from '@reverbdotcom/commons/src/rc/RCIcon';
import ReverbLogoSvg from '@reverbdotcom/commons/design-system/icons/core/reverb-logo.svg?component';
import URLHelpers from './shared/url_helpers';
import UrlHelpers from '../shared/url_helpers';
import SecureCheckoutMessage from './secure_checkout_message';

export default function CheckoutHeader() {
  return (
    <>
      <header className="checkout-header">
        <div className="checkout-header__inner">
          <div className="checkout-header__content">
            <CoreLink
              to={UrlHelpers.rootPath}
              className="checkout-header__logo"
              aria-label={I18n.t('discovery.checkoutHeader.reverb')}
            >
              <RCIcon svgComponent={ReverbLogoSvg} />
            </CoreLink>
            <SecureCheckoutMessage />
            <CoreLink
              to={URLHelpers.cartPath}
              className="checkout-header__back-link"
            >
              {I18n.t('discovery.checkoutHeader.backToCart')}
            </CoreLink>
          </div>
        </div>
      </header>
    </>
  );
}
